export default __webpack_public_path__ + "static/media/expand_less.0b481514.svg";